import * as React from "react";
import Card from "semantic-ui-react/dist/commonjs/views/Card";
import {PricingCardsTranslations} from "i18n/containers/Pricing/PricingCards/typing";
import {PricingCardsTexts} from "i18n/containers/Pricing/PricingCards";
import {useLocales} from "@libs";

const CardPlanForTalentsForProfilesWithAgreement = () => {
    const {currentShortLocale} = useLocales();
    const pricingCardsTranslations: PricingCardsTranslations = {
        ...PricingCardsTexts[currentShortLocale],
    };
    return (
        <Card
            className={"CardPlans CardPlanForTalentsForProfilesWithAgreement"}
            fluid
        >
            <Card.Content>
                <Card.Header className={"price"}>
                    <span className={"symbol"}/>
                    {pricingCardsTranslations.free}
                </Card.Header>
                <Card.Meta>
                    <h4>{pricingCardsTranslations.vingletFriends}</h4>
                </Card.Meta>
            </Card.Content>
            <Card.Content extra>
                <Card.Description>
                    <p> {pricingCardsTranslations.availableForProfilesWithAgreement} </p>
                    <ul className={"padding-0-all"}>
                        <li> - {pricingCardsTranslations.accelerators} </li>
                        <li> - {pricingCardsTranslations.incubators} </li>
                        <li> - {pricingCardsTranslations.institutions} </li>
                    </ul>
                </Card.Description>
            </Card.Content>
            {/*<Card.Content extra>
            <a>
                <Button fluid color={"black"}>
                    {pricingCardsTranslations.chooseProduct}
                </Button>
            </a>
        </Card.Content>*/}
            <Card.Content extra>
                <p> {pricingCardsTranslations.textForSignAgreementWithUs} </p>
            </Card.Content>
        </Card>
    );
};

export default CardPlanForTalentsForProfilesWithAgreement;
